function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import store from "./store";
import account from "./templates/account";
import { localizeProductData, updateStateAddressForm, updateStateShippingAddressForm, getSizeStockData, renderSummaryItemImages, renderSummaryItemImagesCart, renderReceiptItem, renderStates, renderCountries, renderPaymentMethodsLogo } from "./templates/partials";
import { purifier } from "../util/dom";
import { deepClone } from "../util/object";
import { paymentMethodsMap } from "../config";
import loadImages from "../util/loadImages";
import completeSystemSlider from '../components/sliders/complete-system';
import { validatePostalCode } from "../util/string";
import country from "../partials/top/country";
import { trackPurchase } from "../components/stoked";
import { isBundle, monify } from "../components/bundles";
var firstRender = true;
var renderCartItemPrice = function renderCartItemPrice(item, cache) {
  // prettier-ignore
  return cache.price.showAsOnSale ? "\n\t\t<div class=\"price is-sale\">\n\t\t\t<del>".concat(purifier(item.priceEachBeforeDiscount || cache.price.priceBeforeDiscount), "</del> ").concat(purifier(item.priceEach || cache.price.price), "\n\t\t</div>\n\t") : "\n\t\t<div class=\"price\">\n\t\t\t".concat(purifier(item.priceEach || cache.price.price), "\n\t\t</div>\n\t");
};
var renderCheckoutItemSize = function renderCheckoutItemSize(item, cache, selectionItems) {
  return Object.keys(cache.sizes).map(function (size) {
    var sizeValue = cache.sizes[size];
    var sizeId = [sizeValue.sku, sizeValue.name].join('-');
    var lowStock = renderLowStockItem(sizeValue.item, cache);
    var sizeClass = sizeValue.name.toLowerCase().replace(' ', '') === 'onesize' ? 'size-modifier-one-size' : '';
    // prettier-ignore
    return "\n\t\t\t<li class=\"size-selector-item".concat(lowStock ? " low-stock-tooltip js-low-stock-tooltip" : "", "\">\n\t\t\t\t<div class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input type=\"radio\" id=\"size-").concat(sizeId.toLowerCase(), "\" class=\"custom-control-input js-esc-product-item\"\n\t\t\t\t\t\tname=\"esc_product_item\" value=\"").concat(sizeValue.item, "\" ").concat($.inArray(sizeValue.item, selectionItems) !== -1 ? ' checked' : '', "\n\t\t\t\t\t\t").concat(sizeValue.stock === 0 ? ' disabled' : '', ">\n\t\t\t\t\t<label class=\"custom-control-label\" for=\"size-").concat(sizeId.toLowerCase(), "\">\n\t\t\t\t\t\t<span class=\"").concat(sizeClass, "\">").concat(sizeValue.name, "</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t").concat(lowStock ? "\n\t\t\t\t<div class=\"low-stock-tooltip-content js-low-stock-tooltip-content p-0\">\n\t\t\t\t\t<div class=\"low-stock-tooltip-label\">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<img src=\"/wp-content/themes/stellar/dist/images/icon/low-stock.svg\" alt=\"".concat(window.sitewide.lowStock.title, "\">\n\t\t\t\t\t\t\t<span class=\"low-stock-tooltip-title\">").concat(window.sitewide.lowStock.title, "</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p class=\"low-stock-tooltip-title-desc text-white mb-0\">").concat(window.sitewide.lowStock.text, "</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t") : "", "\n\t\t\t</li>\n\t\t\t");
  }).join('');
};
var renderLowStockItem = function renderLowStockItem(item, cache) {
  var stockInfo = getSizeStockData(item, cache);
  if (item.hasOwnProperty('line')) {
    // console.log(stockInfo);
    $(document).ready(function () {
      var cartAddBtn = $('#js-selectedItems div.cart-list ul.cart-items li[data-line="' + item.line + '"]');
      if (cartAddBtn.length > 0) {
        cartAddBtn.find('.qty span[data-action="increase"]').each(function (i, el) {
          if (stockInfo.addedInCart < stockInfo.sizeInStock) {
            $(el).prop('disabled', false).css('opacity', 1);
          } else {
            $(el).prop('disabled', true).css('opacity', .2);
          }
        });
      }
      var checkoutAddBtn = $('#js-checkoutPageItems div.checkout-product-item[data-line="' + item.line + '"]');
      if (checkoutAddBtn.length > 0) {
        checkoutAddBtn.find('.checkout-product-quantity span[data-action="increase"]').each(function (i, el) {
          if (stockInfo.addedInCart < stockInfo.sizeInStock) {
            $(el).prop('disabled', false).css('opacity', 1);
          } else {
            $(el).prop('disabled', true).css('opacity', .2);
          }
        });
      }
    });
  }
  return stockInfo.sizeInStock && stockInfo.sizeInStock <= window.sitewide.lowStock.count ? window.sitewide.lowStock.label : "";
};
var renderCartItem = function renderCartItem(item, cache) {
  var _cache$swatch2;
  var checkout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!cache) return "";
  cache = localizeProductData(cache);

  // prettier-ignore
  if (isBundle(item)) {
    var _store$getState = store.getState(),
      productCache = _store$getState.productCache;
    return "\n\t\t<li class=\"item js-cartItem\" data-line=\"".concat(purifier(item.line), "\" data-quantity=\"").concat(purifier(item.quantity), "\">\n\t\t\t<div class=\"product-details-inline text-left js-analytics is-bundle\">\n\t\t\t\t").concat(renderSummaryItemImagesCart(item, cache), "\n\n\t\t\t\t<div class=\"info\">\n\t\t\t\t\t<div class=\"info-details\">\n\t\t\t\t\t\t<div class=\"item-info\">\n\t\t\t\t\t\t\t<a href=\"").concat(window.sitewide.prefix, "bundle/").concat(purifier(cache.uri), "/\" class=\"h5 name\">").concat(purifier(cache.name), "</a>\n\t\t\t\t\t\t</div>\n                        ").concat(item.bundle.map(function (item) {
      var _cache$swatch;
      var cache = item.product in productCache.items ? localizeProductData(productCache.items[item.product]) : false;
      if (!cache) {
        return "";
      }
      var sub = [];
      if ((_cache$swatch = cache.swatch) !== null && _cache$swatch !== void 0 && _cache$swatch.desc) sub.push(cache.swatch.desc);
      if (item !== null && item !== void 0 && item.size) sub.push("Size ".concat(item.size));
      return "<div class=\"item-info-sub\">\n                                <a href=\"".concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"small name\">").concat(cache.name, " <span class=\"small sub\">| ").concat(sub.join(' | '), "</span></a>\n                            </div>");
    }).join(""), "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"qty-price\">\n\t\t\t\t\t\t").concat(renderCartItemPrice(item, cache), "\n\t\t\t\t\t</div>\n\t\t\t\t\t").concat(renderLowStockItem(item, cache), "\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"close-pos\">\n\t\t\t\t\t<button class=\"btn btn-icon btn-icon-sm close-btn js-update-quantity\" data-action=\"remove\" type=\"button\">\n\t\t\t\t\t\t<img src=\"/wp-content/themes/stellar/dist/images/icon/close.svg\" alt=\"\" srcset=\"\">\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</li>");
  }
  return "\n    <li class=\"item js-cartItem\" data-line=\"".concat(purifier(item.line), "\" data-quantity=\"").concat(purifier(item.quantity), "\">\n        <div class=\"product-details-inline text-left js-analytics\">\n            ").concat(renderSummaryItemImagesCart(item, cache), "\n\n            <div class=\"info\">\n                <div class=\"info-details\">\n                    <div class=\"item-info\">\n                        <a href=\"").concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"h5 name\">").concat(cache.name, "<span class=\"small sub\">").concat((_cache$swatch2 = cache.swatch) === null || _cache$swatch2 === void 0 ? void 0 : _cache$swatch2.desc, " | Size ").concat(item.size, "</span></a>\n                    </div>\n\t\t\t\t</div>\n                <div class=\"qty-price\">\n\t\t\t\t\t<div class=\"qty\">\n\t\t\t\t\t\t<span class=\"is-hover-orange mr-3 js-update-quantity\" data-action=\"decrease\" data-href=\"\">-</span>\n\t\t\t\t\t\t").concat(purifier(item.quantity), "\n\t\t\t\t\t\t<span class=\"is-hover-orange ml-3 js-update-quantity\" data-action=\"increase\" data-href=\"\">+</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t").concat(renderCartItemPrice(item, cache), "\n\t\t\t\t</div>\n                ").concat(renderLowStockItem(item, cache), "\n            </div>\n\n            <div class=\"close-pos\">\n                <button class=\"btn btn-icon btn-icon-sm close-btn js-update-quantity\" data-action=\"remove\" type=\"button\">\n                    <img src=\"/wp-content/themes/stellar/dist/images/icon/close.svg\" alt=\"\" srcset=\"\">\n                </button>\n            </div>\n        </div>\n    </li>");
};
var renderCheckoutItem = function renderCheckoutItem(item, cache) {
  var _cache$swatch4;
  if (!cache) return "";
  cache = localizeProductData(cache);

  // prettier-ignore
  if ("bundle" in item && item.bundle) {
    var _store$getState2 = store.getState(),
      productCache = _store$getState2.productCache;
    return "<div class=\"checkout-product-item is-bundle js-cartItem\" data-line=\"".concat(purifier(item.line), "\" data-quantity=\"").concat(purifier(item.quantity), "\" data-item=\"").concat(purifier(item.item), "\">\n            ").concat(renderSummaryItemImages(item, cache), "\n            <div class=\"checkout-product-info\">\n                <div class=\"checkout-product-details\">\n                    <a href=\"").concat(window.sitewide.prefix, "bundle/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(purifier(cache.name), "</a>\n                </div>\n                ").concat(item.bundle.map(function (item) {
      var _cache$swatch3;
      var cache = item.product in productCache.items ? localizeProductData(productCache.items[item.product]) : false;
      if (!cache) {
        return "";
      }
      var sub = [];
      if ((_cache$swatch3 = cache.swatch) !== null && _cache$swatch3 !== void 0 && _cache$swatch3.desc) sub.push(cache.swatch.desc);
      if (item !== null && item !== void 0 && item.size) sub.push("Size ".concat(item.size));
      return "<div class=\"checkout-product-details checkout-product-subdetails\">\n                        <a href=\"".concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(cache.name, " <span class=\"sub\">| ").concat(sub.join(' | '), "</span></a>\n                    </div>");
    }).join(""), "\n                <div class=\"checkout-product-meta\">\n                    <div class=\"checkout-product-price\">\n                        <div class=\"price\">").concat(renderCartItemPrice(item, cache), "</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"checkout-product-remove js-update-quantity\" data-action=\"remove\">\n                <svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                    <g id=\"BTN/Close_WhiteBG\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                        <polygon id=\"_\" fill=\"#000000\" fill-rule=\"nonzero\" transform=\"translate(19.750000, 19.875000) rotate(-315.000000) translate(-19.750000, -19.875000) \" points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n                        </polygon>\n                        <polygon id=\"_\" fill=\"#000000\" fill-rule=\"nonzero\" transform=\"translate(19.750000, 19.875000) rotate(-45.000000) translate(-19.750000, -19.875000) \" points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n                        </polygon>\n                    </g>\n                </svg>\n            </div>\n            <div class=\"spinner-wrapper\">\n                <div class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></div>\n            </div>\n        </div>");
  }
  return "\n\t<div class=\"checkout-product-item js-cartItem\" data-line=\"".concat(purifier(item.line), "\" data-quantity=\"").concat(purifier(item.quantity), "\" data-item=\"").concat(purifier(item.item), "\">\n\t\t").concat(renderSummaryItemImages(item, cache), "\n        <div class=\"checkout-product-info\">\n            <div class=\"checkout-product-details\">\n                <a href=\"").concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(cache.name, " <span class=\"sub\"><span class=\"d-none d-lg-inline\">| </span>").concat((_cache$swatch4 = cache.swatch) === null || _cache$swatch4 === void 0 ? void 0 : _cache$swatch4.desc, " | Size ").concat(item.size, "</span></a>\n            </div>\n            <div class=\"checkout-product-meta\">\n                <div class=\"checkout-product-quantity\">\n\t\t\t\t\t<div class=\"checkout-product-control\">\n\t\t\t\t\t\t<span class=\"control-minus js-update-quantity\" data-action=\"decrease\">-</span>\n\t\t\t\t\t\t<span class=\"control-input\">").concat(purifier(item.quantity), "</span>\n\t\t\t\t\t\t<span class=\"control-plus js-update-quantity\" data-action=\"increase\">+</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t").concat(renderLowStockItem(item, cache), "\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"checkout-product-price\">\n\t\t\t\t\t").concat(renderCartItemPrice(item, cache), "\n\t\t\t\t</div>\n            </div>\n        </div>\n        <div class=\"checkout-product-remove js-update-quantity\" data-action=\"remove\">\n            <svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                <g id=\"BTN/Close_WhiteBG\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                    <polygon id=\"_\" fill=\"#000000\" fill-rule=\"nonzero\"\n                        transform=\"translate(19.750000, 19.875000) rotate(-315.000000) translate(-19.750000, -19.875000) \"\n                        points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n                    </polygon>\n                    <polygon id=\"_\" fill=\"#000000\" fill-rule=\"nonzero\"\n                        transform=\"translate(19.750000, 19.875000) rotate(-45.000000) translate(-19.750000, -19.875000) \"\n                        points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n                    </polygon>\n                </g>\n            </svg>\n        </div>\n        <div class=\"spinner-wrapper\">\n            <div class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></div>\n        </div>\n\t</div>\n  ");
};
var renderCheckoutItemSlider = function renderCheckoutItemSlider(item, cache, selectionItems) {
  if (!cache) return "";
  cache = localizeProductData(cache);
  var addedProducts = selectionItems.map(function (item) {
    return item.slice(0, item.indexOf("-"));
  });

  // prettier-ignore
  return "\n\t<div class=\"checkout-system-slider-item\">\n\t\t<div class=\"checkout-system-slider-product\">\n\t\t\t<div class=\"checkout-system-slider-wrapper\">\n\t\t\t\t".concat(renderSummaryItemImages(item, cache), "\n\t\t\t\t<div class=\"checkout-product-details\">\n\t\t\t\t\t<a href=\"").concat(window.sitewide.prefix, "product/").concat(purifier(cache.uri), "/\" class=\"checkout-product-name\">").concat(purifier(cache.name), "</a>\n\t\t\t\t\t<div class=\"checkout-product-color\">").concat(purifier(cache.variantName), "</div>\n\t\t\t\t\t<div class=\"d-flex align-items-center justify-content-between\">\n\t\t\t\t\t\t<div class=\"checkout-product-size\">").concat(renderCartItemPrice(item, cache), "</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"checkout-system-slider-desc\">\n\t\t\t\t").concat(purifier(cache.excerpt), "\n\t\t\t</div>\n\t\t\t<form class=\"js-addToCart\" action=\"#\">\n\t\t\t\t<ul class=\"size-selector d-inline-block w-100\">\n\t\t\t\t\t").concat(renderCheckoutItemSize(item, cache, selectionItems), "\n\t\t\t\t</ul>\n\n\t\t\t\t<button class=\"btn btn-lg btn-outline-secondary js-add-to-cart").concat($.inArray(item, addedProducts) !== -1 ? ' is-added' : '', "\" type=\"submit\" data-added=\"is-added\">\n\t\t\t\t\t<div class=\"icon-check\">\n\t\t\t\t\t\t<svg width=\"14px\" height=\"10px\" viewBox=\"0 0 14 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t\t\t\t\t\t<g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t<g id=\"CheckBox/Checked\" transform=\"translate(-8.000000, -10.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t<g id=\"tick\" transform=\"translate(8.000000, 10.000000)\">\n\t\t\t\t\t\t\t\t\t\t<path d=\"M13.7949734,0.199426269 C13.5216183,-0.0664754229 13.0784313,-0.0664754229 12.8050215,0.199426269 L4.41859422,8.35644869 L1.19498878,5.22105338 C0.921633641,4.95515169 0.478446682,4.95517829 0.205036859,5.22105338 C-0.0683456197,5.48692848 -0.0683456197,5.91798815 0.205036859,6.18388985 L3.92361826,9.80066348 C4.19689136,10.0665386 4.64040644,10.0663524 4.91357017,9.80066348 L13.7949734,1.16228933 C14.0683559,0.89641423 14.0683285,0.46532796 13.7949734,0.199426269 Z\" id=\"Path\"></path>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>\n\t\t\t\t\t<span class=\"js-cartButtonLabel\" data-added=\"").concat(window.sitewide.inCartText, "\" data-default=\"").concat(window.sitewide.addToCart, "\">").concat($.inArray(item, addedProducts) !== -1 ? window.sitewide.inCartText : window.sitewide.addToCart, "</span>\n\t\t\t\t\t<span class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></span>\n\t\t\t\t</button>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n  ");
};
var renderAddOnProducts = function renderAddOnProducts(items) {
  var _store$getState3 = store.getState(),
    productCache = _store$getState3.productCache,
    selection = _store$getState3.selection;
  var pricelist = store.getState().store.pricelist;
  var priceLimit = window.sitewide.addOnLimit[pricelist] ? parseFloat(window.sitewide.addOnLimit[pricelist]) : 9999999999;
  var productSkus = items.map(function (item) {
    return item.sku;
  });
  var productSort = {};
  var products = [];

  // Get all upsell products related to items added to cart
  if (productCache && productCache.items) {
    Object.keys(items).forEach(function (key) {
      var item = items[key].item;
      var product = item.slice(0, item.indexOf("-")); // Extract product id from item id
      var upsell = productCache.items[product] && productCache.items[product].upsell ? productCache.items[product].upsell : [];
      if (upsell) {
        products = products.concat(upsell.filter(function (item, index) {
          var _cache$price;
          // This will be used for sorting products
          if (!productSort.hasOwnProperty(item)) productSort[item] = parseInt(index);
          var cache = productCache.items[item];
          if (!cache) {
            return false;
          }
          var sku = (cache === null || cache === void 0 ? void 0 : cache.sku) || '';
          var skuNotExists = productSkus.indexOf(sku) < 0;

          // Return false if product is less than the price limit set in the sitewide
          if (parseFloat(cache === null || cache === void 0 ? void 0 : (_cache$price = cache.price) === null || _cache$price === void 0 ? void 0 : _cache$price.priceAsNumber) > priceLimit) return false;

          // Return false if product is out of stock
          if (parseInt(cache === null || cache === void 0 ? void 0 : cache.inStock) === 0) return false;

          // Return true if the current product sku still not on the list
          if (skuNotExists) {
            productSkus.push(sku);
            return true;
          }
          return false;
        }));
      }
    });
  }
  products = _toConsumableArray(new Set(products));

  // Sort combined upsell products
  var sortedProducts = products.sort(function (a, b) {
    a = parseInt(productSort[a], 10);
    b = parseInt(productSort[b], 10);
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  });
  var html = sortedProducts.map(function (item) {
    return renderCheckoutItemSlider(item, productCache.items[item], selection.items.map(function (item) {
      return item.item;
    }));
  }).join('');
  return html ? "<div class=\"checkout-system-slider js-complete-system-slider invisible\">".concat(html, "</div>") : '';
};
var renderDutyConsent = function renderDutyConsent(countryCode) {
  var totals = store.getState().selection.totals;
  var country = store.getState().store.country;
  var container = $('#checkout-duties');
  var cCode = countryCode == undefined ? country : countryCode;
  var dutyConsent = window.sitewide.dutyconsent;
  var duty = dutyConsent.country[cCode];
  var grandtotal = totals ? totals.grandTotalPriceAsNumber : 0;
  if (duty == undefined || grandtotal <= parseFloat(duty.price_limit)) {
    return container.hide();
  } else {
    var bgColor = '';
    var textColor = '';
    if (typeof duty.bg_color !== 'undefined' && duty.bg_color) {
      var classes = duty.bg_color.split('_');
      bgColor = classes[0] || '';
      textColor = classes[1] || '';
    }
    return container.show().html("\n\t\t<div class=\"checkout-subsection checkout-duties ".concat(purifier(bgColor), " ").concat(purifier(textColor), "\">\n\t\t\t<div class=\"h4 checkout-subsection-title ").concat(purifier(textColor), "\">").concat(purifier(duty.title), "</div>\n\t\t\t<div>").concat(purifier(duty.message), "</div>\n\t\t\t<small>").concat(purifier(duty.learn_more), "</small>\n\t\t\t<div class=\"custom-control custom-checkbox\">\n\t\t\t\t").concat(duty.required ? "\n\t\t\t\t\t<input id=\"checkout-dutyConsent\" class=\"custom-control-input\" name=\"dutyConsent\" value=\"1\" type=\"checkbox\">\n\t\t\t\t\t<label class=\"custom-control-label ".concat(purifier(textColor), "\" for=\"checkout-dutyConsent\">").concat(purifier(duty.terms || 'I accept'), "</label>\n\t\t\t\t") : '', "\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"checkout-subsection-cut checkout-subsection-cut-").concat(purifier(bgColor.replace('bg-', '') || 'orange'), "\"></div>")); //is-invalid - checkbox
  }
};
var renderCountryNotice = function renderCountryNotice(countryCode) {
  var _store$getState$store = store.getState().store,
    country = _store$getState$store.country,
    state = _store$getState$store.state;
  var shippingAddress = store.getState().payment.shippingAddress;
  var items = store.getState().selection.items;
  var _store$getState4 = store.getState(),
    countries = _store$getState4.countries;
  var container = $('#country-notice');
  var cCode = countryCode == undefined ? country : countryCode;
  var countryNotice = window.sitewide.countryNotice;
  var notice = countryNotice && countryNotice[cCode] ? countryNotice[cCode] : {};
  var showMessage = true;

  // Set showmessage state based on state filter
  if (notice.centra_state != undefined && notice.centra_state && countries[cCode].states != undefined && countries[cCode].states) {
    var currentStateName = countries[cCode].states[shippingAddress.state] || '';
    var filterState = notice.centra_state.split("<br />").map(function (item) {
      return item.replace('\r\n', '').trim().toUpperCase();
    });
    showMessage = $.inArray(currentStateName.toUpperCase(), filterState) !== -1;
  }

  // Set showmessage state based on cart Item SKUs, and if current country/state match a settting in the sitewide
  if (showMessage && notice.product_sku != undefined && notice.product_sku.length) {
    var cartSku = items.map(function (item) {
      return (item.sku + item.variant).toUpperCase();
    });
    var matchSku = notice.product_sku.filter(function (x) {
      return cartSku.includes(x);
    });
    showMessage = matchSku.length > 0;
  }
  if (Object.keys(notice).length === 0 || showMessage == false) {
    return container.hide();
  } else {
    var img = '';
    if (sitewide.countryNoticeLogo) {
      img = "<img class=\"mr-3\" src=\"".concat(purifier(sitewide.countryNoticeLogo), "\" alt=\"Prop65 Warning\" />");
    }
    return container.show().html("\n\t\t<div class=\"checkout-subsection checkout-prop65-warning\">\n\t\t\t<div class=\"d-flex align-items-center\">\n\t\t\t  ".concat(purifier(img), "\n        <div>\n          ").concat(purifier(notice.message), "\n        </div>\n\t\t\t</div>\n\t\t</div>\n\t  \t<div class=\"checkout-subsection-cut\"></div>"));
  }
};
var renderProductItemPrice = function renderProductItemPrice(item, cache) {
  var hasMultiplePrices = cache.hasOwnProperty('connectedProducts') && Object.values(cache.connectedProducts).length > 0,
    from = hasMultiplePrices ? window.sitewide.from + ' ' : '';

  // prettier-ignore
  return cache.inStock === 0 ? "\n\t\t<div class=\"product-card-price is-out-of-stock\"><del>".concat(from).concat(purifier(item.priceEach || cache.price.price), "</del></div>\n\t") : cache.price.is_sale ? "\n\t\t<div class=\"product-card-price\">\n\t\t\t<div>".concat(from).concat(purifier(item.priceEach || cache.price.price), " <del>").concat(from).concat(purifier(item.priceEachBeforeDiscount || cache.price.priceBeforeDiscount), "</del></div>\n\t\t</div>\n  \t") : "\n\t\t<div class=\"product-card-price\">\n\t\t<div>".concat(from).concat(purifier(item.priceEach || cache.price.price), "</div>\n\t\t</div>\n  \t");
};
var renderProductImages = function renderProductImages(item, cache) {
  var images = cache.image.length > 1 ? [cache.image[0], cache.image[cache.image.length - 1]] : cache.image;

  //<img class="js-lazy" data-src="{!! $image->src !!}" data-srcset="{!! $image->srcSet !!}" sizes="{{ $image->sizes }}" alt="{{ $image->alt }}" />
  // prettier-ignore
  return "\n      <div class=\"product-card-image ".concat(images.length > 1 ? 'has-second-image' : '', "\">\n\t\t").concat(images.map(function (image) {
    return "<img class=\"js-lazy\" data-srcset=\"".concat(purifier(image).replace(/\.([^.]+)$/, "-sc_large.$1"), " 800w, ").concat(purifier(image).replace(/\.([^.]+)$/, "-sc_standard.$1"), " 500w\" sizes=\"(max-width: 500px) 500px, 800px\" alt=\"").concat(purifier(cache.name), "\" src=\"").concat(purifier(window.sitewide.imagePlaceholder), "\"/>");
  }).join(""), "\n      </div>\n      ").concat(cache.price.is_flash_sale ? "<div class=\"product-card-caption ".concat(purifier(window.sitewide.flashSaleColor), "\"><span>") + purifier(window.sitewide.flashSale) + '</span></div>' : '', "\n  ");
};
var renderProductBadge = function renderProductBadge(text) {
  return "<div class=\"product-card-badge\">".concat(purifier(text), "</div>");
};
var renderProductItem = function renderProductItem(item, cache) {
  if (!cache) return "";
  cache = localizeProductData(cache);
  var variantName = cache.variantName;
  var disabledVariantHoverCategories = ['necklaces', 'bracelets'];
  if (cache.categories.length > 0 && cache.categories.filter(function (category) {
    return disabledVariantHoverCategories.includes(category.toLowerCase());
  }).length > 0) variantName = cache.name;
  var connectedSizes = cache.sizes.map(function (size) {
    size.name = size.name || (cache.hasOwnProperty('oneSizeName') ? cache.oneSizeName : null) || window.sitewide.oneSize;
    return size;
  });
  var allStock = cache.inStock;
  if (cache.hasOwnProperty('connectedProducts') && Object.values(cache.connectedProducts).length > 0) {
    connectedSizes = [].concat(_toConsumableArray(connectedSizes), _toConsumableArray(Object.values(cache.connectedProducts).map(function (product) {
      var currentProduct = store.getState().productCache.items[product];
      if (currentProduct === undefined) return null;
      allStock += currentProduct.inStock;
      return currentProduct.sizes.map(function (size) {
        var productData = store.getState().productCache.items[product];
        size.name = size.name || (productData.hasOwnProperty('oneSizeName') ? productData.oneSizeName : null) || window.sitewide.oneSize;
        return size;
      });
    }).filter(function (size) {
      return size;
    }).reduce(function (acc, val) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
    }, [])));
    connectedSizes = connectedSizes.sort(function (a, b) {
      return a.name.trim() > b.name.trim() ? 1 : -1;
    });
  }
  var productCardClass = allStock === 0 ? 'is-out-of-stock' : cache.price.showAsOnSale ? ' is-sale' : '';

  // prettier-ignore
  return "\n  <div class=\"product-item\" data-product-id=\"".concat(item, "\">\n      <a href=\"").concat(window.sitewide.prefix, "product/").concat(cache.uri, "/\" class=\"product-card ").concat(productCardClass, "\">\n        <div class=\"product-card-media\">\n        ").concat(renderProductImages(item, cache), "\n        </div>\n        <div class=\"product-card-content\">\n          ").concat(allStock === 0 ? renderProductBadge(window.sitewide.soldOut) : '', "\n          ").concat(cache.price.is_new ? renderProductBadge(window.sitewide.newProduct) : '', "\n          ").concat(cache.badges ? Object.values(cache.badges).map(function (badge) {
    return renderProductBadge(badge);
  }).join("") : '', "\n\n\t\t  <div class=\"product-card-firstView\">\n\t\t    <div class=\"product-card-title\">").concat(purifier(cache.name), "</div>\n\t\t\t").concat(renderProductItemPrice(item, cache), "\n\t\t  </div>\n\n          <div class=\"product-card-hoverView\">\n\t\t  <div class=\"product-card-variant\">").concat(purifier(variantName), "</div>\n              <div class=\"product-card-sizeList\">\n\t\t\t\t").concat(connectedSizes.map(function (size) {
    return "<div class=\"product-card-size ".concat(size.stock > 0 || size.stock === "infinite" ? '' : 'is-out-of-stock', "\">").concat(size.name, "</div>");
  }).join(""), "\n              </div>\n          </div>\n        </div>\n      </a>\n    </div>");
};
var renderProductPagePrice = function renderProductPagePrice(item, cache) {
  var hasMultiplePrices = cache.hasOwnProperty('connectedProducts') && Object.values(cache.connectedProducts).length > 0,
    from = hasMultiplePrices ? "<span class=\"js-from-price\">".concat(window.sitewide.from, " </span>") : '';

  // prettier-ignore
  return cache.inStock === 0 ? "\n\t\t<div class=\"product-card-price is-out-of-stock\"><del>".concat(from).concat(purifier(item.priceEach || cache.price.price), "</del></div>\n  \t") : cache.price.is_sale ? "\n\t\t<div class=\"product-card-price is-sale\">\n\t\t".concat(from).concat(purifier(item.priceEach || cache.price.price), "<del>").concat(purifier(item.priceEachBeforeDiscount || cache.price.priceBeforeDiscount), "</del>\n\t\t</div>\n  \t") : "\n\t\t<div class=\"product-card-price\">\n\t\t".concat(from).concat(purifier(item.priceEach || cache.price.price), "\n\t\t</div>\n  \t");
};
var renderCheckoutVouchers = function renderCheckoutVouchers(vouchers) {
  if (vouchers.length === 0) return "";
  // prettier-ignore
  return vouchers.map(function (voucher) {
    return "\n    <div class=\"checkout-discount-code-text\">\n      <div class=\"d-flex align-items-center\">\n        <div class=\"checkout-discount-code-remove js-removeVoucher\" data-voucher=\"".concat(purifier(voucher.voucher), "\">\n          <svg width=\"30px\" height=\"30px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n            <g id=\"BTN/Close_WhiteBG\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n              <polygon id=\"_\" fill=\"#FB5E00\" fill-rule=\"nonzero\" transform=\"translate(19.750000, 19.875000) rotate(-315.000000) translate(-19.750000, -19.875000) \" points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n              </polygon>\n              <polygon id=\"_\" fill=\"#FB5E00\" fill-rule=\"nonzero\" transform=\"translate(19.750000, 19.875000) rotate(-45.000000) translate(-19.750000, -19.875000) \" points=\"28.5 20.4 28.15 20.75 11.35 20.75 11 20.4 11 19.35 11.35 19 28.15 19 28.5 19.35\">\n              </polygon>\n            </g>\n          </svg>\n        </div>\n        <h4 class=\"mb-0\">").concat(purifier(voucher.voucher), "</h4>\n      </div>\n    </div>\n  ");
  });
};
var renderCountriesSiteWide = function renderCountriesSiteWide(escStore, countries) {
  if (typeof countries === "undefined" || _typeof(countries) !== "object") return "";

  // prettier-ignore
  return Object.keys(countries).filter(function (country) {
    return countries[country].shipTo;
  }).map(function (country) {
    return "\n      <option class=\"select-item\" data-currency=\"".concat(countries[country].currency, "\" data-value=\"").concat(country, "\"").concat(escStore.country === country ? ' selected="selected"' : '', ">").concat(countries[country].name, " / ").concat(countries[country].currency, "</option>\n    ");
  });
};
var renderCountriesCustomDropdown = function renderCountriesCustomDropdown(escStore, countries) {
  if (typeof countries === "undefined" || _typeof(countries) !== "object") return "";

  // prettier-ignore
  return Object.keys(countries).filter(function (country) {
    return countries[country].shipTo;
  }).map(function (country) {
    return "\n\t\t<li class=\"cart-dropdown-item".concat(escStore.country === country ? ' active' : '', "\" data-value=\"").concat(country, "\">\n\t\t\t<span class=\"country-flag fi fi-").concat(country.toLowerCase(), "\"></span>\n\t\t\t<h5 class=\"cart-dropdown-country\">").concat(countries[country].name, "</h5>\n\t\t</li>\n    ");
  });
};
var renderShippingChoices = function renderShippingChoices(methods, totals, selected) {
  if (typeof methods === 'undefined' || methods.length === 0) return "";

  // prettier-ignore
  return methods.map(function (method) {
    return "\n    <div class=\"shipping-list-item shipping-list-item-".concat(purifier(method.name).toLowerCase().indexOf('dhl') !== -1 ? 'dhl' : purifier(method.shippingMethod), "\">\n      <div class=\"custom-control custom-radio\">\n        <input id=\"shipping-").concat(purifier(method.shippingMethod), "\" class=\"custom-control-input\" type=\"radio\" name=\"shipping\" value=\"").concat(purifier(method.shippingMethod), "\"").concat(selected === method.shippingMethod ? ' checked="checked"' : '', ">\n        <label class=\"custom-control-label custom-control-label--price\" for=\"shipping-").concat(purifier(method.shippingMethod), "\">\n          <span class=\"custom-control-text-left\"><div class=\"custom-control-image-left\"></div>").concat(purifier(method.name), "</span>\n          <span class=\"custom-control-text-right\">").concat(purifier(totals.shippingPriceAsNumber === 0 ? window.sitewide.freeShipping : method.price), "</span>\n        </label>\n      </div>\n    </div>\n  ");
  });
};
var renderPaymentChoices = function renderPaymentChoices(methods, selected) {
  if (typeof methods === 'undefined' || methods.length === 0) return "";
  var sortedMethods = methods.map(function (method) {
    var sort = 999;
    var paymentMethodLogos = window.sitewide.paymentMethodLogos || {};
    if (paymentMethodLogos && paymentMethodLogos.method) {
      var pos = Object.keys(paymentMethodLogos.method).indexOf(method.paymentMethod);
      sort = pos !== -1 ? pos : sort;
    }
    method.sort = sort;
    return method;
  }).sort(function (a, b) {
    return a.sort - b.sort;
  });

  // prettier-ignore
  return sortedMethods.map(function (method) {
    return "\n\t<div class=\"checkout-payment-item\">\n\t\t<div class=\"custom-control custom-control-lg  custom-radio\">\n\t\t\t<input id=\"payment-".concat(purifier(method.paymentMethod), "\" type=\"radio\" name=\"payment\" value=\"").concat(purifier(method.paymentMethod), "\" class=\"custom-control-input\"").concat(selected === method.paymentMethod ? ' checked="checked"' : '', ">\n\t\t\t<label class=\"custom-control-label\" for=\"payment-").concat(purifier(method.paymentMethod), "\">\n\t\t\t\t<span>").concat(purifier(method.name), "</span>\n\t\t\t</label>\n\t\t</div>\n\t\t<div class=\"checkout-payment-icon\">\n\t\t\t").concat(window.sitewide.paymentMethodLogos.method && window.sitewide.paymentMethodLogos.method[method.paymentMethod] ? window.sitewide.paymentMethodLogos.method[method.paymentMethod].map(function (type) {
      return "\n\t\t\t\t\t<img src=\"".concat(type.src, "\" alt=\"").concat(type.alt, "\">\n\t\t\t\t");
    }).join('') : '', "\n\t\t</div>\n\t</div>\n  ");
  });
};
var updatePaymentFormPlaceholders = function updatePaymentFormPlaceholders() {
  var fields = $('#js-checkoutPaymentForm .js-form-input');
  if (fields.length === 0) return;
  var country = store.getState().store.country;

  // Get default payment form translations
  var defaultPaymentForm = window.sitewide.defaultPaymentForm || {};
  var paymentForm = {};

  // Get country payment form translation
  if (window.sitewide.paymentForm && window.sitewide.paymentForm[country]) {
    paymentForm = window.sitewide.paymentForm[country];
  }
  fields.each(function (i, item) {
    var el = $(item);
    var isDropdown = el.parent().hasClass('custom-dropdown');
    var name = isDropdown ? el.data('name') : el.attr('name');
    var placeholder = defaultPaymentForm[name] || '';
    if (typeof paymentForm[name] !== 'undefined' && paymentForm[name]) {
      placeholder = paymentForm[name];
    }
    if (!placeholder) return;
    if (el.parent().hasClass('custom-dropdown')) {
      var parent = el.parents('.form-group');
      if (parent.length) {
        parent.find('.custom-dropdown button').text(placeholder);
        el.find(".dropdown-item[data-value='']").text(placeholder);
      }
    } else {
      el.attr('placeholder', placeholder);
    }
  });
};
var updateMessageForm = function updateMessageForm() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (message) {
    $("#js-checkoutPageMessage").addClass("is-toggled").find("textarea").val(message);
  }
};
var renderNewsletterInput = function renderNewsletterInput(paymentMethod) {
  var klarnaWrap = $('#js-newsletterInputKlarna');
  var adyenWrap = $('#js-newsletterInputAdyen');
  var wrapper, toHide;
  if (paymentMethod === 'klarna') {
    wrapper = klarnaWrap;
    toHide = adyenWrap;
  } else {
    wrapper = adyenWrap;
    toHide = klarnaWrap;
  }
  if (wrapper.length === 0) return;
  var field = wrapper.find('.js-checkboxInputs');
  wrapper.show();
  toHide.hide();
  field.html("\n\t<input id=\"newsletterCheckout\" class=\"custom-control-input\" type=\"checkbox\" name=\"newsletter\" value=\"1\" />\n\t<label class=\"custom-control-label\" for=\"newsletterCheckout\">".concat(field.data('label') || "Stay updated with our newsletter", "</label>\n"));
  SelectedModal.appendEventFromWrap(wrapper[0]);
};
var displaySummaryItem = function displaySummaryItem(els) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  els.each(function (i, item) {
    var el = $(item);
    var showClass = el.data('show-class') ? el.data('show-class') : '';
    if (el && value) {
      el.text(text).parent().removeClass('d-none').addClass(showClass);
    } else {
      el.parent().removeClass(showClass).addClass('d-none');
    }
  });
};

/* Updates cart list in header */
var updateCart = function updateCart(selection, productCache, newProduct) {
  var items = "",
    moreItems = "",
    mobileCartItems = "";
  var currency = store.getState().store.currency;
  if (selection.items.length > 0) {
    items = selection.items.map(function (item) {
      return renderCartItem(item, productCache[item.item.slice(0, item.item.indexOf("-"))]);
    });
    if ($('.js-cart-products').length != 0) {
      var cartContent = $('.js-cart-products');
      cartContent.find('.cart-title').text(cartContent.data('item-added')).removeClass('mb-0');
      cartContent.find('.cart-summary').removeClass('d-none');
      cartContent.find('.cart-dropdown').removeClass('d-none');
      cartContent.find('.cart-buttons').removeClass('d-none');
    }
  } else {
    // Empty cart
    if ($('.js-cart-products').length != 0) {
      var _cartContent = $('.js-cart-products');
      _cartContent.find('.cart-title').text(_cartContent.data('no-item')).addClass('mb-0');
      _cartContent.find('.cart-summary').addClass('d-none');
      _cartContent.find('.cart-dropdown').addClass('d-none');
      _cartContent.find('.cart-buttons').addClass('d-none');
    }
  }
  if (!selection.totals || selection.totals.totalQuantity === 0) {
    $(".js-item-count").addClass('d-none');
  } else {
    $(".js-item-count").removeClass('d-none').find('span').text(selection.totals.totalQuantity);
  }
  $("#js-items-initial").html(items);
  mobileCartItems = selection.items.map(function (item) {
    return renderCartItem(item, productCache[item.item.slice(0, item.item.indexOf("-"))]);
  });
  $("#js-items-recent").html(mobileCartItems);
  if (moreItems && selection.items.length > 3 || selection.items.length > 1 && newProduct) {
    $("#js-items-more").html(moreItems);
    $('#js-items-show-all').show();
    $('.js-items-more-count').text(newProduct ? selection.items.length - 1 : selection.items.length - 3);
  } else {
    $('#js-items-show-all').hide();
    $("#js-items-more").html('');
    $('.js-items-more-count').text('');
  }
  $(".js-cart-summary-item-total").text(selection.totals.itemsTotalPrice);
  var discount = $(".js-cart-summary-discount");
  displaySummaryItem(discount, selection.totals.totalDiscountPriceAsNumber, selection.totals.totalDiscountPrice);
  var shippingText = selection.totals.shippingPrice;
  if (sitewide.excludeShipping) {
    shippingText = sitewide.excludeShipping;
  }
  $(".js-cart-summary-shipping").text(shippingText);

  // Exlude shipping from total
  var cartPartialTotal = selection.totals.grandTotalPriceAsNumber || 0;
  if (selection.totals.shippingPriceAsNumber && sitewide.excludeShipping) {
    cartPartialTotal -= selection.totals.shippingPriceAsNumber;
  }
  $(".js-cart-summary-grand").text(monify(cartPartialTotal, currency));
  $("#js-cart-header-count").text(selection.totals.totalQuantity);
  $("#js-cart-summary-count").text(selection.totals.totalQuantity + ' ' + (selection.totals.totalQuantity == 1 ? $("#js-cart-summary-count").data('singular') : $("#js-cart-summary-count").data('plural')));

  /* Render added vouchers */
  if (selection.discounts) {
    $(".js-checkoutPageVoucher").find(".js-addedVouchers").html(renderCheckoutVouchers(selection.discounts.vouchers));
  }
};

// eslint-disable-next-line
var updateCheckoutPage = function updateCheckoutPage(selection, payment, productCache, escStore, countries, checkoutLogin) {
  var selectionErrors = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var vouchers = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var shipwallet = arguments.length > 8 ? arguments[8] : undefined;
  var useShippingAddress = arguments.length > 9 ? arguments[9] : undefined;
  if (selection.items && selection.items.length > 0) {
    // eslint-disable-next-line
    var totals = selection.totals,
      discounts = selection.discounts,
      shippingMethods = selection.shippingMethods,
      shippingMethod = selection.shippingMethod,
      paymentMethods = selection.paymentMethods,
      paymentFields = selection.paymentFields,
      paymentMethod = selection.paymentMethod;
    var items = selection.items.filter(function (item) {
      return typeof productCache[item.item.slice(0, item.item.indexOf("-"))] !== 'undefined';
    }).map(function (item) {
      return renderCheckoutItem(item, productCache[item.item.slice(0, item.item.indexOf("-"))]);
    });

    /* Order items */
    $("#js-checkoutPageItems").html(items);

    /* Addons */
    var addOns = renderAddOnProducts(selection.items);
    $("#js-checkoutPageAddOns").html(renderAddOnProducts(selection.items));
    $("#js-checkoutPageAddOns").parents(".checkout-subsection-wrapper").toggle(!!addOns);

    /* Duty consent */
    renderDutyConsent();
    renderCountryNotice();

    /* Render added vouchers */
    $(".js-checkoutPageVoucher").find(".js-addedVouchers").html(renderCheckoutVouchers(discounts.vouchers));
    var hasItems = selection.items.length > 0;
    var totalContainer = $(".js-checkoutPageTotals,#js-checkoutPageSummarySubmit");

    // Discount
    var discount = totalContainer.find(".js-discount");
    displaySummaryItem(discount, selection.totals.totalDiscountPriceAsNumber, selection.totals.totalDiscountPrice);

    // Tax
    var vat = totalContainer.find(".js-vat");
    displaySummaryItem(vat, hasItems ? selection.totals.grandTotalPriceTaxAsNumber : false, selection.totals.grandTotalPriceTax);
    totalContainer.find(".js-vat-percent").text(selection.totals.taxPercent);

    // item total
    var itemTotal = totalContainer.find(".js-subTotal");
    displaySummaryItem(itemTotal, hasItems ? selection.totals.itemsTotalPrice : false, selection.totals.itemsTotalPrice);

    // Shipping
    var shipping = totalContainer.find(".js-shipping");
    displaySummaryItem(shipping, hasItems ? selection.totals.shippingPrice : false, selection.totals.shippingPrice);

    // Grand total
    var grandTotal = totalContainer.find(".js-grandTotal");
    displaySummaryItem(grandTotal, hasItems ? selection.totals.grandTotalPrice : false, selection.totals.grandTotalPrice);

    // Payment method logos
    $(".js-checkoutPaymentLogos").html(renderPaymentMethodsLogo(escStore));
    $("#js-countryRepeat").val(countries[escStore.country] ? countries[escStore.country].name : '');
    var isShippable = escStore.country && countries[escStore.country] && countries[escStore.country].shipTo;
    var countryName = isShippable ? countries[escStore.country].name : 'Select country';
    $("#js-checkoutPageDelivery").find(".js-country").html(renderCountries(escStore, countries, true)).end().find(".js-country-text").text(countryName);
    $("#js-checkoutAccount").find(".js-checkoutHideLogin").toggle(!checkoutLogin && !payment.loggedIn).end().find(".js-checkoutShowLogin").toggle(checkoutLogin && !payment.loggedIn).end().find(".js-checkoutHideLogout").toggle(!payment.loggedIn).end().find(".js-checkoutShowLogout").toggle(!!payment.loggedIn);
    $("#js-checkoutAccount").find(".js-checkoutShowRegister").toggle(!!payment.createAccount);
    if (typeof countries !== 'undefined' && countries[escStore.country] && countries[escStore.country].states) {
      var currentStateName = countries[escStore.country].states[payment.shippingAddress.state] ? countries[escStore.country].states[payment.shippingAddress.state] : window.sitewide.chooseState;
      $("#js-checkoutPageDelivery").find(".js-state").parent().css({
        display: "inline-block"
      }).end().html(renderStates(escStore, countries[escStore.country].states, payment.shippingAddress.state || '')).end().find(".js-state-text").text(currentStateName);
      $("#js-stateRepeat").parent().show().end().val(currentStateName);
      $("#js-checkoutPageAddressForm").find(".js-state").parents(".form-group").show().end().html(renderStates(escStore, countries[escStore.country].states, payment.address.state || '')).end().find(".js-state-text").text(countries[escStore.country].states[payment.address.state] ? countries[escStore.country].states[payment.address.state] : window.sitewide.chooseState);
      if (countries[escStore.country].states[payment.address.state]) {
        $("#js-checkoutPaymentForm .js-state[data-group=\"address\"]").val(payment.address.state);
      }
      if (countries[escStore.country].states[payment.shippingAddress.state]) {
        $("#js-checkoutPaymentForm .js-state[data-group=\"shippingAddress\"]").val(payment.shippingAddress.state);
      }
    } else {
      $("#js-checkoutPageDelivery").find(".js-state").parent().hide();
      $("#js-checkoutPageAddressForm").find(".js-state").parents(".form-group").hide();
      $("#js-stateRepeat").parent().hide();
    }
    $("#js-shippingChoices").html(renderShippingChoices(shippingMethods, totals, shippingMethod));

    /* Payment Choices */
    $("#js-paymentChoices").html(renderPaymentChoices(paymentMethods, paymentMethod)).closest('.js-section').toggleClass('d-none', paymentMethods.length <= 1);
    $(".js-timeline-payment").toggleClass('d-none', paymentMethods.length <= 1);
    $(".js-timeline-adyen").toggleClass('d-none', !(paymentMethods.length <= 1 && paymentMethod.indexOf('adyen') !== -1));
    $('.js-section:not(.is-hidden) .js-number').each(function (i, el) {
      $(el).text("".concat(i + 1, "."));
    });

    /* Render useShippingAsBilling */
    $("#js-useShippingAddress").prop('checked', !useShippingAddress ? true : false);
    $('#js-checkoutPageAddressForm').toggle(useShippingAddress);
    $(".js-shipping-title").text(useShippingAddress ? $(".js-shipping-title").data('shipping') : $(".js-shipping-title").data('default'));

    // $('#js-checkoutPageShippingAddressForm .js-form-input').attr("data-group", (useShippingAddress ? 'shippingAddress' : 'address'));

    var checkoutAddressFormFields = deepClone(paymentFields.address);
    if (payment.createAccount) {
      if (_typeof(checkoutAddressFormFields.password) !== 'object') checkoutAddressFormFields.password = {};
      if (_typeof(checkoutAddressFormFields.passwordRepeat) !== 'object') checkoutAddressFormFields.passwordRepeat = {};
      checkoutAddressFormFields.password.visible = true;
      checkoutAddressFormFields.passwordRepeat.visible = true;
    }

    // Remove errors
    $('.invalid-feedback').remove();
    updateStateShippingAddressForm(paymentFields.shippingAddress, payment.shippingAddress, 'checkout-');
    updateStateAddressForm(checkoutAddressFormFields, payment.address, 'checkout-');
    updateMessageForm(payment.additionalNotes);
    updatePaymentFormPlaceholders();

    // zipcode warning
    var invalidAddressZipCode = payment.address.zipCode ? validatePostalCode(escStore.country, payment.address.zipCode) : false;
    var invalidShippingZipCode = payment.shippingAddress.zipCode ? validatePostalCode(escStore.country, payment.shippingAddress.zipCode) : false;
    var invalidZipCode = !useShippingAddress && invalidShippingZipCode || useShippingAddress && (invalidAddressZipCode || invalidShippingZipCode);
    $('#js-selectionZipCodeWarning').toggle(!!invalidZipCode);

    // Payment method
    if (paymentMethodsMap.klarnaCheckout.indexOf(paymentMethod) !== -1) {
      // Klarna
      $("#js-checkoutPageSummarySubmit,#js-checkboxInputs-terms,#js-checkoutPaymentForm").hide();
      $("#js-klarnaCheckout").show();

      // Use shipping field
      $(".js-useShippingAddress-field").hide();
      $(".js-acceptTerms-field").addClass('col-lg-12').removeClass('col-lg-6');
      renderNewsletterInput('klarna');
    } else {
      $("#js-checkoutPageSummarySubmit,#js-checkboxInputs-terms,#js-checkoutPaymentForm").show();
      $("#js-klarnaCheckout").hide();

      // Use shipping field
      $(".js-useShippingAddress-field").show();
      $(".js-acceptTerms-field").addClass('col-lg-6').removeClass('col-lg-12');
      renderNewsletterInput('adyen');
    }
    $("#js-checkoutPageDelivery,#js-checkoutPageAddressForm,#js-checkboxInputs-terms,.js-checkboxInputs,#checkout-duties").find('input').each(function (i, el) {
      var $input = $(el);
      var id = $input.attr('name');
      var inputType = $input.attr('type');
      if (inputType === 'checkbox' && (payment[id] || payment.address[id])) $input.prop('checked', true);else if (inputType === 'checkbox' && typeof payment[id] !== 'undefined') $input.prop('checked', !!payment[id]);else if ($input.val() !== payment.address[id] && payment.address[id]) $input.val(payment.address[id]);
    });

    // Gift Wrap
    $('#js-giftWrap').toggleClass('is-giftWrap', !!payment.additionalNotes).find('textarea')
    // Remove text on first line of text on additional notes
    // (first line is just notification of gift wrapping being applied)
    .val((payment.additionalNotes || '').replace(/^.*[\s]*/, '')).end().find('#js-toggleGiftWrap span').text(payment.additionalNotes ? $('#js-toggleGiftWrap').data('remove') : $('#js-toggleGiftWrap').data('add'));

    // Toggle errors
    $('#terms-checkbox-checkout').toggleClass('is-invalid', !!paymentFields.termsAndConditions.error);
    if (paymentFields.termsAndConditions.error) $('#terms-checkbox-checkout').addClass('is-invalid').siblings('label').after("<div class=\"invalid-feedback\">".concat(window.sitewide.accountEntryErrors.accept_terms || "Accept term is required", "</div>"));
    $('#js-selectionGeneralError').toggle(!!selectionErrors.selectionErrorPayment);
    $('#js-selectionStockError').toggle(!!selectionErrors.selectionErrorStock);
    $('#js-selectionRegisterError').toggle(!!selectionErrors.selectionErrorRegistered);
    $('#js-selectionVoucherError').toggle(!!vouchers.error);

    // Toggle Customs Duty errors
    // $( '#checkout-dutyConsent' ).toggleClass( 'is-invalid', !!selectionErrors.selectionErrorDutyConsent );
    if (selectionErrors.selectionErrorDutyConsent) $('#checkout-dutyConsent').addClass('is-invalid').siblings('label').after("<div class=\"invalid-feedback text-white\">".concat(window.sitewide.dutyconsent.error || "Accept customs duties is required", "</div>"));
    if (selectionErrors.selectionError || selectionErrors.selectionErrorStock || selectionErrors.selectionErrorPayment || selectionErrors.selectionErrorRegistered) {
      $('#js-purchase').parent().show();
      $('#checkout-adyen').hide();
    }
    $("#js-checkout").show();
    $("#js-emptyCheckout").hide();
  } else {
    var _selection$totals = selection.totals,
      _totals = _selection$totals === void 0 ? false : _selection$totals;
    $("#js-checkoutPageItems").html("");
    $(".js-checkoutPageTotals,#js-checkoutPageSummarySubmit").find(".js-subTotal").text(_totals.itemsTotalPrice).end().find(".js-discount").parent().toggle(!!_totals.totalDiscountPrice).end().text(_totals.totalDiscountPrice).end().find(".js-shipping").text(_totals.shippingPriceAsNumber === 0 ? window.sitewide.freeShipping : _totals.shippingPrice).end().find(".js-grandTotal").text(_totals.grandTotalPrice).end().find(".js-vat").text(

      // totals.grandTotalPriceTaxAsNumber === 0
      // 	? ""
      // 	: $( "#js-checkoutPageTotals" )
      // 		.find( ".js-vat" )
      // 		.data( "text" )
      // 		.replace( "%amount%", totals.grandTotalPriceTax )
    );
    /*
    end()
    		.find( ".js-vat" )
    .parent()
    .css( "display",
    	$( "#js-checkoutPageTotals" )
    		.find( ".js-vat" )
    		.text()
    		? ""
    		: "none" )
    */

    $("#js-checkout").hide();
    $("#js-emptyCheckout").show();
    $('#js-selectionStockErrorEmpty').toggle(!!selectionErrors.selectionErrorStock);
  }
};

// eslint-disable-next-line
var updateReceiptPage = function updateReceiptPage(selection, payment, productCache) {
  if (selection.items.length > 0) {
    var items = selection.items.map(function (item) {
      return renderReceiptItem(item, productCache[item.item.slice(0, item.item.indexOf("-"))]);
    });
    var totals = selection.totals,
      _selection$receiptSni = selection.receiptSnippet,
      receiptSnippet = _selection$receiptSni === void 0 ? "" : _selection$receiptSni,
      _selection$paymentMet = selection.paymentMethodName,
      paymentMethodName = _selection$paymentMet === void 0 ? "Debug" : _selection$paymentMet,
      _selection$shippingMe = selection.shippingMethodName,
      shippingMethodName = _selection$shippingMe === void 0 ? "Debug" : _selection$shippingMe;
    $("#js-receiptSnippet").parent().toggle(!!receiptSnippet);
    if (receiptSnippet) $("#js-receiptSnippet").html(receiptSnippet);
    $("#js-receiptPageItems").html(items);
    $("#js-receiptPageSummary").show();
    $("#js-receiptPageSummary").find(".js-orderNumber").text(window.tokens.debug ? "DEBUG" : selection.order);
    $.event.trigger('stoked-purchase', [selection, trackPurchase]);
    var hasItems = selection.items.length > 0;
    var totalContainer = $("#js-receiptPageTotals");

    // Discount
    var discount = totalContainer.find(".js-discount");
    displaySummaryItem(discount, hasItems ? selection.totals.totalDiscountPriceAsNumber : false, selection.totals.totalDiscountPrice);

    // Tax
    var vat = totalContainer.find(".js-vat");
    displaySummaryItem(vat, hasItems ? selection.totals.grandTotalPriceTaxAsNumber : false, selection.totals.grandTotalPriceTax);
    totalContainer.find(".js-vat-percent").text(selection.totals.taxPercent);

    // item total
    var itemTotal = totalContainer.find(".js-subTotal");
    displaySummaryItem(itemTotal, hasItems ? selection.totals.itemsTotalPrice : false, selection.totals.itemsTotalPrice);

    // Shipping
    var shipping = totalContainer.find(".js-shipping");
    displaySummaryItem(shipping, hasItems ? selection.totals.shippingPrice : false, selection.totals.shippingPrice);

    // Grand total
    var grandTotal = totalContainer.find(".js-grandTotal");
    displaySummaryItem(grandTotal, hasItems ? selection.totals.grandTotalPrice : false, selection.totals.grandTotalPrice);
    $("#js-paymentMethod").text(paymentMethodName);
    $("#js-shippingMethod").text(selection.shipwalletMethod ? window.sitewide.shippingMethod[selection.shipwalletMethod] || selection.shipwalletMethod : '---');
    var addressScr = window.tokens.debug ? payment : selection;
    Object.keys(addressScr.address).forEach(function (key) {
      $("[data-cust-".concat(key, "]")).each(function (i, el) {
        $(el).text(addressScr.address[key]);
      });
    });
    $("#js-receiptPageBilling").html(purifier("\n      ".concat(addressScr.address.firstName || "First Name", " ").concat(addressScr.address.lastName || "Last Name", "<br>\n      ").concat(addressScr.address.email || "Email", "<br>\n      ").concat(addressScr.address.phoneNumber || "Phone Number", "<br>\n      ").concat(addressScr.address.address1 || "Address Line 1", "<br>\n      ").concat(addressScr.address.address2 ? "".concat(addressScr.address.address2, "<br>") : "", "\n\t  ").concat(addressScr.address.city || "City", " <br>\n\t  ").concat(addressScr.address.state ? "".concat(addressScr.address.state) : "", "\n\t  ").concat(addressScr.address.zipCode || "Zip Code", "<br>\n    ")));
    $("#js-receiptPageDelivery").html(purifier("\n      ".concat(addressScr.shippingAddress.firstName || addressScr.address.firstName || "First Name", " ").concat(addressScr.shippingAddress.lastName || addressScr.address.lastName || "Last Name", "<br>\n      ").concat(addressScr.shippingAddress.email || addressScr.address.email || "Email", "<br>\n      ").concat(addressScr.shippingAddress.phoneNumber || addressScr.address.phoneNumber || "Phone Number", "<br>\n      ").concat(addressScr.shippingAddress.address1 || addressScr.address.address1 || "Address Line 1", "<br>\n      ").concat(addressScr.shippingAddress.address2 ? "".concat(addressScr.shippingAddress.address2, "<br>") : "", "\n      ").concat(addressScr.shippingAddress.city || addressScr.address.city || "City", "<br>\n\t  ").concat(addressScr.shippingAddress.state ? "".concat(addressScr.shippingAddress.state) : "", "\n\t  ").concat(addressScr.shippingAddress.zipCode || addressScr.address.zipCode || "Zip Code", "\n    ")));
  } else {
    window.location = window.sitewide.paymentFailedPage;
  }
};

// eslint-disable-next-line
var update = function update() {
  // console.log("DEBUG: store.getState()", deepClone(store.getState()));
  var _store$getState5 = store.getState(),
    selection = _store$getState5.selection,
    payment = _store$getState5.payment,
    favourites = _store$getState5.favourites,
    productCache = _store$getState5.productCache,
    escStore = _store$getState5.store,
    productListCompact = _store$getState5.productListCompact,
    useShippingAddress = _store$getState5.useShippingAddress,
    checkoutLogin = _store$getState5.checkoutLogin,
    countries = _store$getState5.countries,
    selectionErrors = _store$getState5.selectionErrors,
    vouchers = _store$getState5.vouchers,
    shipwallet = _store$getState5.shipwallet;

  // Render / check if account page.
  account(store.getState(), firstRender);
  if (!productCache || Object.keys(productCache).length === 0) {
    console.log("DEBUG: waiting for product cache");
    // return;
  }
  if ($(".js-select--country")) {
    $('.js-languageLocation-toggle--text').text(window.sitewide.language.toUpperCase() + ' | ' + escStore.currency);
    $(".js-select--country").html(renderCountriesSiteWide(escStore, countries));
  }
  if ($(".js-dropdownFlag--country")) {
    var showCountry = escStore.country && countries[escStore.country] && countries[escStore.country].shipTo;
    var flag = $('.js-dropdownFlag-toggle--flag');
    if (flag.length > 0) {
      flag.each(function (i, el) {
        var classes = el.className.replace(/\bfi-*[a-z]{2}\b/g, '');
        if (showCountry) {
          classes = "".concat(classes, " fi-").concat(escStore.country.toLowerCase());
        }
        el.className = classes;
      });
    }
    var countryName = showCountry ? countries[escStore.country].name : '';
    $('.js-dropdownFlag-toggle--text').text(countryName);
    $(".js-dropdownFlag--country").html(renderCountriesCustomDropdown(escStore, countries));
    country();
  }
  var productItems = '';
  if ($('.taxonomy-silk_category-data').length > 0) {
    productItems = $(".product-item").not('.product-list .product-item');
  } else {
    productItems = $(".product-item");
  }
  if (productItems.length > 0) {
    console.log('rerender product currrency', productItems);
    productItems.each(function (i, product) {
      if ($(product).data('product-id')) {
        $(product).replaceWith(renderProductItem($(product).data('product-id'), productCache.items[$(product).data('product-id')]));
      }
    });
    loadImages();
  }
  if ($('#js-products')) {
    $('.products-details-form').removeClass('d-none');
    $('.js-switchable-price').each(function (i, product) {
      if ($(product).data('product-id')) {
        console.log('rerender product page price');
        if (productCache.items[$(product).data('product-id')]) {
          $(product).html(renderProductPagePrice($(product).data('product-id'), productCache.items[$(product).data('product-id')]));
          $('.product-addToCart').show();
          $('.product-sticky-inner-action').show();
        } else {
          $(product).html(window.sitewide.productUnavailable);
          $('.product-addToCart').hide();
          $('.product-sticky-inner-action').hide();
        }
      }
    });
  }
  if ($("body.category").length > 0) $("body.category").toggleClass("u-compact", productListCompact);
  if ($(".js-cart-overlay").length > 0 && selection.items) updateCart(selection, productCache.items);
  if ($("#js-checkoutPageItems").length > 0) {
    // eslint-disable-next-line
    updateCheckoutPage(selection, payment, productCache.items, escStore, countries, checkoutLogin, selectionErrors, vouchers, shipwallet, useShippingAddress);
    completeSystemSlider.init();
  }
  if ($("#js-receiptPageSummary").length > 0) {
    $("#js-receiptPageSummary").hide();
  }
  if ($("#js-receiptPageItems").length > 0 && selection.items && (selection.order || !selection.order && window.tokens.debug)) updateReceiptPage(selection, payment, productCache.items);

  // if ( $( ".js-favourites" ).length > 0 ) updatePageFavourites( favourites );

  // if ( $( "#js-favourites" ).length > 0 )
  // 	updateFavourites( favourites, productCache.items );

  // if ( $( "#js-favouritesPage" ).length > 0 )
  // 	updateFavouritesPage( favourites, productCache.items );

  if (firstRender) {
    $(window).trigger("store.firstRender", store.getState());
    firstRender = false;
  }
  $(window).trigger("store.updated", store.getState());
};
var updateCartNewAdded = function updateCartNewAdded(item) {
  var _store$getState6 = store.getState(),
    selection = _store$getState6.selection,
    productCache = _store$getState6.productCache;
  if (!productCache || Object.keys(productCache).length === 0) {
    console.log("DEBUG: waiting for product cache");
    return;
  }
  if ($(".js-cart-overlay").length > 0 && selection.items) {
    updateCart(selection, productCache.items, item);
  }
};
var renderReceiptPage = function renderReceiptPage() {
  var pageData = window.sitewide.thankyouPage;
  var section = $('section.checkout-v2-thankyou');
  var message = section.find('.checkout-thankyou-message');
  var product = section.find('.checkout-product');
  var grandtotal = section.find('.checkout-grand-total');
  var snippet = section.find('.checkout-confirmation');
  var orderId = store.getState().selection.order || 0;
  // if( orderId == 0 ) {
  // 	return window.location = window.sitewide.paymentFailedPage;
  // }
  var receiptSnippet = store.getState().selection.receiptSnippet || '';
  var address = store.getState().selection.address;
  var items = store.getState().selection.items;
  var totals = store.getState().selection.totals;
  if (pageData.success_msg != null) {
    message.find('H1').text(pageData.success_msg + ' #' + orderId);
  }
  if (address != undefined) {
    message.find('div.content h3').html(pageData.dear + '&nbsp;' + address.firstName + '&nbsp' + address.lastName + ',');
  }
  message.find('div.content p').text(pageData.message);
  if (pageData.links.length > 0) {
    message.find('div.checkout-thankyou-links').html(pageData.links.map(function (link) {
      return "<a href=\"" + link.url + "\">" + link.label + "</a>";
    }).join("<span class=\"ml-1 mr-1\">|</span>"));
  }
  // if ( items == undefined ) { window.location.reload(); return false; }
  product.find('.checkout-subsection-title').text(pageData.order_title || 'YOUR ORDER OVERVIEW');
  product.find('.checkout-product-list').html(items.map(function (item) {
    return renderReceiptItems(item);
  }).join(''));
  grandtotal.find('.checkout-grand-total-title').text(window.sitewide.grandTotal || 'Grand Total');
  grandtotal.find('.checkout-grand-total-breakdown').html(renderReceiptTotals(totals));
  snippet.html(receiptSnippet);
};
var renderReceiptItems = function renderReceiptItems(item) {
  return "<div class=\"checkout-product-item\">\n\t\t<figure class=\"checkout-product-image\">\n\t\t<img class=\"lazy\"\n\t\t\tdata-src=\"https://stellar.centracdn.net/client/dynamic/images/84_9d37814a1d-1blublack-01-m-stellar-shell-jacket-mini.png\">\n\t\t</figure>\n\t\t<div class=\"checkout-product-info\">\n\t\t<div class=\"checkout-product-details\">\n\t\t\t<div class=\"checkout-product-name\">".concat(purifier(item.name), "</div>\n\t\t\t<div class=\"checkout-product-color\">").concat(purifier(item.variant), "</div>\n\t\t\t<div class=\"checkout-product-size\">").concat(purifier(item.size), "</div>\n\t\t</div>\n\t\t<div class=\"checkout-product-meta\">\n\t\t\t<div class=\"checkout-product-qty checkout-product-details\">\n\t\t\t<small>QTY ").concat(purifier(item.quantity), "</small>\n\t\t\t</div>\n\t\t\t<div class=\"checkout-product-price\">\n\t\t\t").concat(purifier(item.priceEach), "\n\t\t\t</div>\n\t\t</div>\n\t\t</div>\n\t</div>");
};
var renderReceiptTotals = function renderReceiptTotals(total) {
  return "<div class=\"d-flex justify-content-between breakdown-item breakdown-total\">\n\t<div>".concat(purifier(window.sitewide.subTotal || 'Total Price'), "</div>\n\t<div>").concat(purifier(total.itemsTotalPrice), "</div>\n  </div>\n  <div class=\"d-flex justify-content-between breakdown-item breakdown-shipping\">\n\t<div>").concat(purifier(window.sitewide.shipping || 'Shipping'), "</div>\n\t<div>").concat(purifier(total.shippingPrice), "</div>\n  </div>\n  <div class=\"d-flex justify-content-between breakdown-item breakdown-vat\">\n\t<div>").concat(purifier(window.sitewide.vat || 'VAT'), "</div>\n\t<div>").concat(purifier(total.grandTotalPriceTax), "</div>\n  </div>\n  <div class=\"d-flex justify-content-between breakdown-item breakdown-grand-total\">\n\t<div>").concat(purifier(window.sitewide.grandTotal || 'Grand Total'), "</div>\n\t<div>").concat(purifier(total.grandTotalPrice), "</div>\n  </div>");
};
export { renderProductItem, updateCartNewAdded, updateCart, update, renderDutyConsent, renderReceiptPage };
export default update;


// WEBPACK FOOTER //
// ./scripts/shop/render.js